import React, { useContext, useRef, useState } from 'react';
import { MLSMapContext } from '../../context/MLSMapContext';
import useOutsideClick from '../../hooks/useOutsideClick';
import mls_results_sorting from '../../constants/mls_results_sorting.json';

export default function MLSSortDropdown() {
  const dropdownRef = useRef();

  const {
    sortDropdownVisible,
    setSortDropdownVisible,
    sortBy,
    setSortBy,
  } = useContext(MLSMapContext);

  const [localSortBy, setLocalSortBy] = useState(sortBy);

  useOutsideClick(dropdownRef, sortDropdownVisible, () => {
    setLocalSortBy(sortBy);
    setSortDropdownVisible(false);
  });

  return (
    <div ref={dropdownRef} className="dropdown-sorting-container">
      <h2 className="dropdown-title">Sort By</h2>
      <button
        aria-label="Clear Sort Dropdown"
        name="Clear Sort Dropdown"
        type="button"
        className="mobile-dropdown-cancel btn btn--small"
        onClick={() => setSortDropdownVisible(false)}
      >
        Close
      </button>
      <section className="dropdown-sorting-inputs">
        {mls_results_sorting.map(type => (
          <label key={type.value} htmlFor={`filters-type-${type.value}`}>
            <input
              aria-label={`${type.label}`}
              id={`filters-type-${type.value}`}
              type="checkbox"
              checked={localSortBy === type}
              onChange={() => {
                if (type === localSortBy) {
                  setLocalSortBy();
                } else {
                  setLocalSortBy(type);
                }
              }}
            />
            <p>{type.label}</p>
          </label>
        ))}
      </section>
      <section className="dropdown-actions mobile-center">
        <button
          aria-label="Apply Sort Filter"
          name="Apply Sort Filter"
          type="button"
          className="btn btn--dark btn--small"
          onClick={() => {
            setSortBy(localSortBy);
            setSortDropdownVisible(false);
          }}
        >
          Apply
        </button>
        <button
          aria-label="Clear Sort Filter"
          name="Clear Sort Filter"
          type="button"
          className="btn btn--light"
          onClick={() => {
            setLocalSortBy('');
            setSortBy('');
          }}
        >
          Clear
        </button>
      </section>
    </div>
  );
}
